export default __webpack_public_path__ + "static/media/undraw_clean_up_re_504g.be8599f1.svg";